
export const isStringURL = (val: string) => {
    const urlRegex = /^(https?:\/\/(?:www\.)?|www\.)[^\s/$.?#].[^\s]*$/i;
    return urlRegex.test(val);
};